// FLOW-05 (ajuste da task 5.2, pedido do Murilo em 13/10) — a mensagem do compilador e do executor
// com o que vem entre crases como código: fonte mono, no tom do texto em volta e sem fundo de cor.
// O texto da mensagem não muda (o compilador escreve `artifact`, `{{#each}}`); só a tela deixa de
// mostrar as crases. A crase sem par fica como está.
import { computed, defineComponent, h } from 'vue';

const CODIGO = /`([^`]+)`/g;

export function partesComCodigo(texto) {
  const fonte = String(texto ?? '');
  const partes = [];
  let ultimo = 0;
  [...fonte.matchAll(CODIGO)].forEach(achado => {
    if (achado.index > ultimo) {
      partes.push({ texto: fonte.slice(ultimo, achado.index), codigo: false });
    }
    partes.push({ texto: achado[1], codigo: true });
    ultimo = achado.index + achado[0].length;
  });
  if (ultimo < fonte.length) {
    partes.push({ texto: fonte.slice(ultimo), codigo: false });
  }
  return partes;
}

// Uma função de render, e não um template: no template, o espaço entre o texto e o `<code>` sumiria
// ou dobraria com a formatação do arquivo. `prefixo` é o rótulo antes da mensagem ("Como resolver: ").
export const TextoDoCompilador = defineComponent({
  name: 'TextoDoCompilador',
  props: {
    texto: { type: String, default: '' },
    prefixo: { type: String, default: '' },
  },
  setup(props) {
    const partes = computed(() => partesComCodigo(props.texto));
    return () =>
      h('span', [
        props.prefixo,
        ...partes.value.map(parte =>
          parte.codigo
            ? h('code', { class: 'font-mono', 'data-codigo': '' }, parte.texto)
            : parte.texto
        ),
      ]);
  },
});
